import {NgModule} from '@angular/core';
import {AngularEditorComponent} from './angular-editor.component';
import {AngularEditorToolbarComponent} from './angular-editor-toolbar.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import { AeSelectComponent } from './ae-select/ae-select.component';
import {MatIconModule} from '@angular/material/icon';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {GlobalModule} from '@app/core/global.module';

@NgModule({
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule, MatIconModule, MatButtonModule, GlobalModule
    ],
  declarations: [AngularEditorComponent, AngularEditorToolbarComponent, AeSelectComponent],
  exports: [AngularEditorComponent, AngularEditorToolbarComponent]
})
export class AngularEditorModule {
}
